import { render } from "./listeAssignations.vue?vue&type=template&id=53ccaeff&ts=true"
import script from "./listeAssignations.vue?vue&type=script&lang=ts"
export * from "./listeAssignations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__